if (!customElements.get('scrolling-text-banner')) {
  customElements.define(
    'scrolling-text-banner',
    class ScrollingTextBanner extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-scrolling-banner-track]');
        this.sequence = this.querySelector('[data-scrolling-banner-sequence]');
        this.baseDuplicate = this.querySelector('[data-scrolling-banner-duplicate]');

        if (!this.track || !this.sequence || !this.baseDuplicate || this.dataset.enabled !== 'true') return;

        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.sequence);
        this.scheduleLayout();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();

        if (this.layoutFrame) {
          cancelAnimationFrame(this.layoutFrame);
        }
      }

      scheduleLayout() {
        if (this.layoutFrame) return;

        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = null;
          this.updateLayout();
        });
      }

      updateLayout() {
        const sequenceWidth = this.sequence.getBoundingClientRect().width;
        const viewportWidth = this.getBoundingClientRect().width;

        if (!sequenceWidth || !viewportWidth) return;

        this.querySelectorAll('[data-scrolling-banner-generated]').forEach((duplicate) => duplicate.remove());

        const totalGroups = Math.max(2, Math.ceil((viewportWidth + sequenceWidth) / sequenceWidth));
        const generatedGroups = Math.max(0, totalGroups - 2);

        for (let index = 0; index < generatedGroups; index += 1) {
          const duplicate = this.baseDuplicate.cloneNode(true);
          duplicate.dataset.scrollingBannerGenerated = '';
          duplicate.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
            control.setAttribute('tabindex', '-1');
          });
          this.track.appendChild(duplicate);
        }

        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const speed = Number(mobile ? this.dataset.speedMobile : this.dataset.speedDesktop) || 50;
        const duration = Math.max(5, sequenceWidth / speed);

        this.style.setProperty('--scrolling-banner-cycle-width', `${sequenceWidth}px`);
        this.style.setProperty('--scrolling-banner-duration', `${duration}s`);
        this.classList.add('is-ready');
      }
    }
  );
}
